// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3DMze","title":"Header_title__32MWA","left":"Header_left__2uAut","clinicName":"Header_clinicName__3Qgm3"};